import React from 'react';
import styled from 'styled-components';
import MUITextField from '@material-ui/core/TextField';

const TextField = styled(props => <MUITextField fullWidth {...props} />)`
  & .MuiInput-underline:before {
    border-bottom: 1px solid ${props => props.theme.colors.environment.divider};
  }

  & .MuiInput-underline::after {
    border-bottom: 2px solid ${props => props.theme.colors.text.primary};
  }

  & .MuiFormLabel-root {
    color: ${props => props.theme.colors.text.secondary};
    padding-left: ${props => props.theme.spacing[2]};
    top: ${props => props.theme.spacing[1]};
  }

  & .MuiFormLabel-root.Mui-focused {
    color: ${props => props.theme.colors.text.secondary};
  }

  & .MuiInput-input {
    ${props => props.theme.typography.subtitle1};
    color: ${props => props.theme.colors.text.primary};
    padding: ${props => props.theme.spacing[2]};
  }
`;

export default TextField;
